export default function () {
  let buyNowButtons = null;
  let cart = null;
  let cartUrl = 'https://www.aafp.org/ams/ecommerce/store/cart';
  let currentCart = [];
  let currentSavedItems = [];

  const apiLoc = 'https://www.aafp.org/api/v2/';

  document.addEventListener('DOMContentLoaded', function () {
    cart = document.querySelector('aafp-shopping-cart');
    buyNowButtons = document.querySelectorAll('aafp-buy-now-button');

    if (cart) {
      cart.cartUrl = cartUrl;
    }

    getCurrentCart();
    setupBuyNotBtns();
  });

  function getCurrentCart() {
    fetch(apiLoc + 'ecommerce/store/cart', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then((response) => {
        if (response && response.Quantity > 0) {
          currentCart = response.Lines;
          if (cart) {
            cart.setItemsCountState(response.Lines.length);
          }
        }
        if (buyNowButtons.length > 0) {
          fetch(apiLoc + 'ecommerce/store/saved-item/list', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
          })
            .then((res) => res.json())
            .then((response) => {
              if (response && response.length > 0) {
                currentSavedItems = response;
              }

              for (var i = 0; i < buyNowButtons.length; i++) {
                const button = buyNowButtons[i];

                for (var j = 0; j < currentCart.length; j++) {
                  if (currentCart[j]['Sku'] === button.sku) button.statusCartAdded = true;
                }
                for (var k = 0; k < currentSavedItems.length; k++) {
                  if (currentSavedItems[k]['Sku'] === button.sku) button.statusSaveAdded = true;
                }
                button.btnStateLoaded = true;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function setupBuyNotBtns() {
    for (var i = 0; i < buyNowButtons.length; i++) {
      const button = buyNowButtons[i];
      var productSku = button.sku;
      if (!productSku) continue;

      button.addEventListener('add2CartClicked', function (e) {
        const isAuthenticated = typeof window.AAFPUserObject !== 'undefined' && window.AAFPUserObject.AAFPID.length > 0;

        if (!isAuthenticated) {
          let returnLocation = window.location.href;
          window.location.href = `https://www.aafp.org/cgi-bin/lg.pl?redirect=${returnLocation}`;
        } else if (e.target.statusCartAdded) {
          window.location.href = cartUrl;
        } else if (!e.target.hasAttribute('disabled')) {
          add2Cart(e.target);
        }
      });

      button.addEventListener('save4LaterClicked', function (e) {
        const isAuthenticated = typeof window.AAFPUserObject !== 'undefined' && window.AAFPUserObject.AAFPID.length > 0;

        if (!isAuthenticated) {
          let returnLocation = window.location.href;
          window.location.href = `https://www.aafp.org/cgi-bin/lg.pl?redirect=${returnLocation}`;
        } else if (e.target.statusSaveAdded) {
          window.location.href = cartUrl + '#saved-items';
        } else {
          e.target.statusSaveError = false;
          e.target.statusSaveAdded = true;
          addSave4Later(e.target);
        }
      });
    }
  }

  function addSave4Later(element) {
    fetch(apiLoc + 'ecommerce/store/saved-item', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ Sku: element.sku }),
    })
      .then((res) => res.json())
      .then((response) => {
        if (!response) {
          element.statusSaveError = true;
          element.statusSaveAdded = false;
        }
      })
      .catch((err) => {
        element.statusSaveError = true;
        element.statusSaveAdded = false;
      });
  }

  function add2Cart(element) {
    element.setAttribute('disabled', 'true');
    element.statusCartLoading = true;

    let productSku = element.sku;

    const param = {
      Sku: element.sku,
      PriceName: element.priceRuleOverride,
      Quantity: 1,
      TrackingCode: element.trackingCode,
    };

    fetch(apiLoc + 'ecommerce/store/cart-item', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(param),
    })
      .then((res) => res.json())
      .then((response) => {
        if (!response) {
          element.removeAttribute('disabled');
          element.statusCartError = true;
          element.statusCartLoading = false;
        } else {
          // var evt = new CustomEvent('cartUpdate', { detail: response.Items });
          // window.dispatchEvent(evt);

          ProcessGoogleDataLayer(productSku);

          element.removeAttribute('disabled');
          element.statusCartError = false;
          element.statusCartLoading = false;
          element.statusCartAdded = true;

          if (cart) {
            cart.setItemsCountState(currentCart.length + 1);
            cart.cartUrl = cartUrl;
          }
        }
      })
      .catch((err) => {
        console.log(err);
        element.removeAttribute('disabled');
        element.statusCartLoading = false;
        element.statusCartError = true;
      });
  }

  function ProcessGoogleDataLayer(sku) {
    const item = window.itemDetails[sku];
    if (item) {
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

      var ecommerceJson = {
        event: 'add_to_cart',
        ecommerce: {
          value: +item.OrderLineItemSalePrice,
          currency: 'USD',
          items: [
            {
              item_id: item.ItemID,
              item_name: item.DisplayName,
              item_brand: item.Type,
              item_category: item.ItemCategory,
              item_category2: item.ItemCategory2,
              item_category3: item.ItemCategory3,
              item_category4: item.ItemCategory4,
              item_category5: item.ItemCategory5,
              item_quantity: 1,
              price: item.Price.Amount,
            },
          ],
        },
      };

      //console.log(ecommerceJson);
      dataLayer.push(ecommerceJson);
    }
  }
}
